import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { getRemotedbUrl, i18nIntl, isNotEmpty } from '../../../lib/ep.js';

import { SecondaryButton } from '../../builder/ActionButton';
import ActionLink from '../../builder/ActionLink';
import ButtonCollection from '../../builder/ButtonCollection.js';
import FieldLabel from '../../builder/FieldLabel';
import FloatingLayer from '../../builder/FloatingLayer';
import InputWithButton from '../../builder/InputWithButton';
import { AlertMessage } from '../../builder/Message.js';
import Model from '../../builder/Model';
import SectionSubtitle from '../../builder/SectionSubtitle';
import SectionTitle from '../../builder/SectionTitle';
import TimeCounterSimple from '../../builder/TimeCounterSimple';
import LinkCollection from '../../ui_items/LinkCollection.js';
import RibbonCollection from '../../ui_items/RibbonCollection.js';
 
export const TestInvitations = ({ promotion_id, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const simultanious_invitations = 3;

	const [ creating_link, setCreatingLink ] = useState(false);
	const [ invitations_model, setInvitationsModel ] = useState({ name_invitation:[] });
	const [ display_invitations, setDisplayInvitations ] = useState(false);
	const [ invitations, setInvitations ] = useState(props?.invitations ?? []);

	const changeInvitationsModel = (k, v) => {
		setInvitationsModel({ ...invitations_model, [k]:v });
	};

	const toggleInvitations = () => {
		if(!display_invitations && invitations.length == 0) loadInvitations();
		setDisplayInvitations(true);
	};

	const createLink = (cb) => {
		if(!creating_link && invitations_model.name_invitation.length > 2) {
			setCreatingLink(true);

			$.post(getRemotedbUrl(`/promotions/create_invitation/${promotion_id}`), {
				name:invitations_model.name_invitation,
			}, (r) => {
				changeInvitationsModel('name_invitation', []);
				setCreatingLink(false);

				loadInvitations();
				if(cb != undefined) cb();
			}, 'JSON');
		}
	};

	const loadInvitations = () => {
		$.post(getRemotedbUrl(`/promotions/load_invitations/${promotion_id}`), (r) => {
			if(r.status) {
				setInvitations(r?.invitations ?? []);
			}
		}, 'JSON');
	};

	const links = [];
	if(invitations.length > 0) {
		invitations.map((item) => {
			let extra = null;
			let ribbon = null;
			switch(item.status) {
				case 'current':
					ribbon = <RibbonCollection
						items={[{
							title:"Active",
							color:'green',
							icon:'knk-on',
						}]}
					/>;
					extra = <TimeCounterSimple
						seconds={item.seconds}
						hide_days={true}
					>Time left to test</TimeCounterSimple>;
					break;

				case 'expired':
					ribbon = <RibbonCollection
						items={[{
							title:"Expired",
							color:'red',
							icon:'knk-off',
						}]}
					/>;
					break;

				default:
					ribbon = <RibbonCollection
						items={[{
							title:i18n("***Pending"),
							autotranslate:false,
							color:'black',
							icon:'knk-off',
						}]}
					/>;
					extra = <TimeCounterSimple
						seconds={EPDateDiff(EPDateAdd(EPGetTimezone(item.created,'Europe/Madrid'), 'days', 1), null, 'seconds')}
						hide_days={true}
					>This link will expire in</TimeCounterSimple>;
					break;
			}

			links.push({
				label:{
					children:((isNotEmpty(item, 'name')) ? item.name : `[ ${i18n("No name")} ]`),
					autotranslate:false,
				},
				urls:[{
					url:`${window.owner_url}test_invite/${promotion_id}/${item.token}`,
					clickable:((item?.used ?? false) === false) ? true : false,
				}],
				extra,
				ribbons:ribbon,
			});
		});
	}

	return (
		<>
			<AlertMessage
				icon={false}
				_class={{ other:'whiteColor redBg in_top in_bottom gui_not_bordered shadow_small' }}
			>
				<p class="gui_force_bold gui_uppercase">{i18n("Promotion in test mode")}</p>

				<p class="gui_not_in_top_small gui_not_in_bottom_small">➡️&nbsp;<ActionLink _href={`${window.public_url}p/${promotion_id}?utm_source=test`} _target="_blank" _class={{other:'gui_underlined_text whiteColor gui_force_bold submit_link'}}>Click here to test the promotion</ActionLink>&nbsp;&nbsp;➡️&nbsp;<ActionLink onClick={() => toggleInvitations()} _class={{other:'gui_underlined_text whiteColor gui_force_bold submit_link'}}>Create an invitation</ActionLink></p>

				<p>{i18n("You can participate as a real user and test all features. When you finish testing, you can delete all users and participations, reset stats, and release any prizes won during the test.")}</p>

				<p>
					<strong>{i18n("Disable the test mode to activate and publish the promotion.")}</strong>
				</p>
			</AlertMessage>

			{(display_invitations) && (
				<FloatingLayer
					_class={{ size:'small' }}
					backButton={() => setDisplayInvitations(false)}
				>
					<div>
						<SectionTitle autotranslate={false}>{i18n("Invitation to test promotion")} ({invitations.length}/{simultanious_invitations})</SectionTitle>

						<SectionSubtitle>Create links to invite others to test the promotion. They don't need to create an Easypromos account.</SectionSubtitle>

						<SectionSubtitle autotranslate={false}>
							<FormattedMessage
								id="You can invite up to {max_invitations} users. Each invitation link is valid for {expiration} once created. When the users accept the invitation, they will be able to test for the next {max_duration}."
								values={{
									max_invitations:simultanious_invitations,
									expiration:`24 ${i18n("hours")}`,
									max_duration:`2 ${i18n("hours")}`
								}}
							/>
						</SectionSubtitle>

						{(invitations.length < simultanious_invitations) && (
							<Model model={invitations_model} change={changeInvitationsModel}>
								<InputWithButton
									_class={{ first:true }}
									name="name_invitation"
									placeholder="Name of the person"
									button_type="submit"
									submitColor={(invitations_model.name_invitation.length < 3) ? 'black' : 'green'}
									submitIcon='knk-add-item'
									onSubmit={(e, cb) => createLink(cb)}
								>Type the name of the person you will send the invitation to</InputWithButton>
							</Model>
						)}

						{(invitations.length > 0) && (
							<div class="gui_not_in_top_big">
								<FieldLabel>Created invitations</FieldLabel>

								<LinkCollection
									items={links}
									_class={{ other:'gui_overflowed_auto' }}
								/>
							</div>
						)}

						<ButtonCollection in_floating={true}>
							<SecondaryButton
								onClick={() => setDisplayInvitations(false)}
							>Close</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}
		</>
	)
};

export default TestInvitations;